var map = {
	"./checkout/billing-address/index.jsx": "./blocks/checkout/billing-address/index.jsx",
	"./checkout/cart/index.jsx": "./blocks/checkout/cart/index.jsx",
	"./components/color.js": "./blocks/components/color.js",
	"./components/typography.js": "./blocks/components/typography.js",
	"./index.js": "./blocks/index.js",
	"./shops-page/shop/components/DualRangeSlider.js": "./blocks/shops-page/shop/components/DualRangeSlider.js",
	"./shops-page/shop/components/Filters.js": "./blocks/shops-page/shop/components/Filters.js",
	"./shops-page/shop/components/Rating.js": "./blocks/shops-page/shop/components/Rating.js",
	"./shops-page/shop/components/RecursiveOptions.js": "./blocks/shops-page/shop/components/RecursiveOptions.js",
	"./shops-page/shop/edit.js": "./blocks/shops-page/shop/edit.js",
	"./shops-page/shop/index.js": "./blocks/shops-page/shop/index.js",
	"./single-product/add-to-cart/components/quantity.js": "./blocks/single-product/add-to-cart/components/quantity.js",
	"./single-product/add-to-cart/edit.js": "./blocks/single-product/add-to-cart/edit.js",
	"./single-product/add-to-cart/index.js": "./blocks/single-product/add-to-cart/index.js",
	"./single-product/attributes/edit.js": "./blocks/single-product/attributes/edit.js",
	"./single-product/attributes/index.js": "./blocks/single-product/attributes/index.js",
	"./single-product/gallery/edit.js": "./blocks/single-product/gallery/edit.js",
	"./single-product/gallery/index.js": "./blocks/single-product/gallery/index.js",
	"./single-product/gallery/inspector.js": "./blocks/single-product/gallery/inspector.js",
	"./single-product/price/edit.js": "./blocks/single-product/price/edit.js",
	"./single-product/price/index.js": "./blocks/single-product/price/index.js",
	"./single-product/price/inspector.js": "./blocks/single-product/price/inspector.js",
	"./single-product/product-tab/assets/script.js": "./blocks/single-product/product-tab/assets/script.js",
	"./single-product/product-tab/components/favorite.js": "./blocks/single-product/product-tab/components/favorite.js",
	"./single-product/product-tab/components/rating.js": "./blocks/single-product/product-tab/components/rating.js",
	"./single-product/product-tab/components/review.js": "./blocks/single-product/product-tab/components/review.js",
	"./single-product/product-tab/components/sku.js": "./blocks/single-product/product-tab/components/sku.js",
	"./single-product/product-tab/edit.js": "./blocks/single-product/product-tab/edit.js",
	"./single-product/product-tab/index.js": "./blocks/single-product/product-tab/index.js",
	"./single-product/product-tab/inspector.js": "./blocks/single-product/product-tab/inspector.js",
	"./single-product/rating/components/favorite.js": "./blocks/single-product/rating/components/favorite.js",
	"./single-product/rating/components/rating.js": "./blocks/single-product/rating/components/rating.js",
	"./single-product/rating/components/sku.js": "./blocks/single-product/rating/components/sku.js",
	"./single-product/rating/edit.js": "./blocks/single-product/rating/edit.js",
	"./single-product/rating/index.js": "./blocks/single-product/rating/index.js",
	"./single-product/rating/inspector.js": "./blocks/single-product/rating/inspector.js",
	"./single-product/stock/edit.js": "./blocks/single-product/stock/edit.js",
	"./single-product/stock/index.js": "./blocks/single-product/stock/index.js",
	"./single-product/stock/inspector.js": "./blocks/single-product/stock/inspector.js",
	"./single-product/summary/edit.js": "./blocks/single-product/summary/edit.js",
	"./single-product/summary/index.js": "./blocks/single-product/summary/index.js",
	"./single-product/summary/inspector.js": "./blocks/single-product/summary/inspector.js",
	"./single-product/thumbnail/edit.js": "./blocks/single-product/thumbnail/edit.js",
	"./single-product/thumbnail/index.js": "./blocks/single-product/thumbnail/index.js",
	"./single-product/title/edit.js": "./blocks/single-product/title/edit.js",
	"./single-product/title/index.js": "./blocks/single-product/title/index.js",
	"./single-product/title/inspector.js": "./blocks/single-product/title/inspector.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./blocks sync recursive \\.(js%7Cjsx%7Ctsx)$";